import React from "react";

function Footer() {
    return(
        <div className="footer">
         <p className="footer-mission">We're committed to finding your perfect ride. </p>
            <div className="copyright">
                  <h5>©2023 All Rights  Reserved | FASTLANE LUXURY MOTORS™</h5>
             </div>
        </div>
    )
}

export default Footer